<div *ngIf="show" class="splash-container"
     [ngStyle]="{'background-image':'url(./assets/img/splash-background.svg)','opacity': opacity}">
  <img class="splash-logo img-fluid" [src]="splash_screen || './assets/img/splash-logo.png'"/>
</div>
